<template>
    <div class="team-match">
        <div class=" col-sm-3 team-match-date text-left">
          <svg class="fill-color" width="15" height="17"><use xlink:href="#calendar"  /></svg> {{ formatDate(match.date_time_jogo) }}
        </div>
        <div class="col-sm-6 team-match-team text-left">
            <template>
                <!--<img :src="require( `../../assets/img/flags/${teams[idadv].data.country.toLowerCase()}.svg`)" height="16">--> {{ teams[idadv].data.name }}
            </template>
        </div>
        <div class="col-sm-3 team-match-score text-right" v-bind:class="{'looser-color': Number( teams[currteam.team.id].data.score) < Number(teams[idadv].data.score), 'winner-color':Number( teams[currteam.team.id].data.score) > Number(teams[idadv].data.score), 'draw-color': Number(teams[currteam.team.id].data.score) === Number(teams[idadv].data.score) }">

            <div class="score">{{ Number( teams[currteam.team.id].data.score) }}</div>
            <div class="score">{{ Number(teams[idadv].data.score) }}</div>

        </div>
    </div>

</template>

<script>

    import Funcs from '../../functions'

    export default {
        name: "PrevMatch",
        props: ['match','currteam'],
        data(){
            return {
                teams:null,
                idadv:null
            };
        },
        created: function(){
            let tteams={};
            for(let k in this.match.teams_formatted){
                tteams[this.match.teams_formatted[k].team.id]=this.match.teams_formatted[k];
                if(this.match.teams_formatted[k].team.id !== this.currteam.team.id){
                    this.idadv=this.match.teams_formatted[k].team.id;
                }

            }
            this.teams=tteams;
        },
        methods: {
            formatDate: function(date){
                return Funcs.formatDate(date,false,true);
            },
            getImageUrl: function(url){
              return Funcs.getImageUrl(url);
            },
        }
    }
</script>

<style scoped>

    .history-info .team-matches > .team-match {
        height: 40px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        color:#FFF;
        font-size: 14px;
        line-height: 40px;
    }

    .history-info .team-matches > .team-match > .team-match-team > img {
        height: 15px;
        margin-right: 10px;
    }

    .team-match-date {
        color: #78838A;
    }

    .team-match-score {
        padding-right:0;
    }

    .team-match-score > .score {
        float: left;
        width: 50%;
        text-align: center;
        font-weight: bold;
        font-size: 13px;
    }

    .team-match-score > .score:first-child {
        border-right: 1px solid #0A151C;
    }
    .team-match-score > .score:last-child {
        border-left: 1px solid #0A151C;
    }
</style>